import React, { useState } from "react";
import { useSelector } from "react-redux";
import CartItem from "./CartItem";
import empty_cart from "../../../assets/images/empty_cart.png";
import { cartInfoStyle as styles } from "./cartInfo.tailwind";
import Button from "../../shared/Button/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import routeConstant from "../../../lib/constants/routeConstant";
import clear_cart_icon from "../../../assets/svgs/delete_icon.svg";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import ClearCart from "../../shared/Modals/ClearCartModal/ClearCartModal";

// This component is for cart table items
const CartInfo = () => {
  const navigate = useNavigate();
  const { products: orderItems, loadingCart } = useSelector((state) => state.cart);

  const [handleOpenModal, setHandleOpenModal] = useState(false);

  const handleClearCart = () => {
    setHandleOpenModal(true);
  };

  // When cart is empty
  if (orderItems?.length === 0 && !loadingCart) {
    return (
      <div className={styles.outer_box} style={{ width: "100%", height: "100%"}}>
        {/* Empty Cart Message */}
        <div className="flex flex-col justify-center items-center">
          <img src={empty_cart} alt="empty cart" className="max-w-[200px] sm:max-w-[300px] md:max-w-[420px]" />
          <div className={styles.emptyCart}>Your cart is empty!</div>
          <div className={styles.button_container}>
            {/* Explore Tokens Button(when we no cart-items) */}
            <Button variant="primary" className={styles.continue_shopping} onClick={() => {navigate(routeConstant.SELECT_SPORT_PAGE)}}>
              Explore Tokens
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.outer_box}>
      <div className={styles.border}>
        {/* Heading(My Cart) */}
        <h1 className={styles.subheading}>My Cart</h1>
        {/* Clear Cart Icon */}
        { orderItems?.length > 0 &&
          <Tooltip title="Clear Cart" arrow>
            <figure className="cursor-pointer min-h-[20px] min-w-[20px]" onClick={handleClearCart}>
              <img src={clear_cart_icon} alt="empty cart" className="w-full h-full"  />
            </figure>
          </Tooltip>
        }
      </div>

      {/* Cart Table */}
      <div className={styles.cart_table}>
        {/* Scrollable Table Body */}
        <div>
          <div className={styles.table_inner}>
            {/* Table Body */}
            <div className={styles.table_body}>
              {/* Table Row Item */}
              {orderItems?.map((item, index) => (
                // Cart Item orderItems contains details of the cart-items
                <CartItem
                  key={index}
                  item={item}
                  isExpandedDefault={true}
                  isLastItem={index === orderItems?.length - 1}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Explore More Tokens */}
      <div className={styles.button_container}>
        {/* Explore More Tokens Button(when we have cart-items) */}
        <Button variant="primary" className={styles.continue_shopping} onClick={() => {navigate(routeConstant.SELECT_SPORT_PAGE)}}>
            <ChevronLeftIcon sx={{fontSize: "20px"}} />
            Explore More Tokens
        </Button>
      </div>

      { handleOpenModal && 
        <ClearCart
          isOpen={handleOpenModal}
          onClose={() => setHandleOpenModal(false)}
        />}
    </div>
  );
};

export default CartInfo;
